import styled from 'styled-components/macro';
import { DropdownStyled } from '@yme/atoms/dropdown';
import { InputStyled } from '@yme/atoms/input';
import { colorCoreGray500 } from '@yme/tokens/colors';
import { FlexWrapper } from '@yme/tokens/flexTokens';
import { INDENT } from '@yme/tokens/sizes';
export const ContainerStyled = styled.div `
  display: flex;
  margin-top: ${INDENT.sm};
  padding-bottom: ${INDENT.sm};
  border-bottom: 1px solid ${colorCoreGray500};

  &:last-child {
    padding-bottom: 0;
    border-bottom: none;
  }

  ${DropdownStyled} {
    width: 100%;
  }
`;
export const OtherReasonInputContainerStyled = styled.div `
  margin-top: 10px;
  ${InputStyled} {
    resize: vertical;
    min-height: 64px;
  }
`;
export const PriceContainerStyled = styled(FlexWrapper) `
  flex-direction: column;
  align-items: flex-end;
  * {
    align-self: inherit;
  }
`;
